"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paypalOnApprove = void 0;
const utils_1 = require("../utils");
const formatPaypalToApiAddress_1 = require("./formatPaypalToApiAddress");
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const types_1 = require("../types");
const managePaypalState_1 = require("./managePaypalState");
const actions_1 = require("../actions");
function paypalOnApprove(data, actions) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { iso_code: currencyCode } = (0, checkout_frontend_library_1.getCurrency)();
        return (_a = actions.order) === null || _a === void 0 ? void 0 : _a.get().then(({ id, payer, purchase_units }) => __awaiter(this, void 0, void 0, function* () {
            var _b;
            // extract all shipping info
            const { name, address: shippingAddress } = purchase_units[0].shipping;
            const shippingNames = (0, utils_1.getFirstAndLastName)(name === null || name === void 0 ? void 0 : name.full_name);
            // extract all billing info
            const { name: payerName, address: billingAddress } = payer;
            const billingNames = { firstName: (payerName === null || payerName === void 0 ? void 0 : payerName.given_name) || '', lastName: (payerName === null || payerName === void 0 ? void 0 : payerName.surname) || '' };
            const phone = ((_b = payer.phone) === null || _b === void 0 ? void 0 : _b.phone_number.national_number) || '';
            const email = payer.email_address || '';
            const isBillingAddressFilled = (!!(billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.address_line_1)
                && !!billingAddress.admin_area_1
                && !!billingAddress.admin_area_2
                && !!billingAddress.country_code
                && !!billingAddress.postal_code);
            // set customer
            const customerResult = yield (0, utils_1.callGuestCustomerEndpoint)(billingNames.firstName, billingNames.lastName, email);
            const success = customerResult.success;
            if (!success) {
                (0, actions_1.displayError)('There was an unknown error while validating your customer information.', 'generic', 'unknown_error');
                return;
            }
            // check if shipping and billing are the same
            const isSameNames = (0, utils_1.isObjectEquals)(shippingNames, billingNames);
            const isSameAddress = isBillingAddressFilled && (0, utils_1.isObjectEquals)(shippingAddress, billingAddress);
            const isBillingSame = isSameNames && isSameAddress;
            const formattedShippingAddress = (0, formatPaypalToApiAddress_1.formatPaypalToApiAddress)(shippingAddress, shippingNames.firstName, shippingNames.lastName, phone);
            const formattedBillingAddress = (0, formatPaypalToApiAddress_1.formatPaypalToApiAddress)(isBillingAddressFilled ? billingAddress : shippingAddress, billingNames.firstName, billingNames.lastName, phone);
            // check and update shipping address
            const shippingAddressResponse = yield (0, utils_1.callShippingAddressEndpoint)(formattedShippingAddress, false);
            if (!shippingAddressResponse.success) {
                (0, actions_1.displayError)('There was an unknown error while validating your shipping address.', 'shipping', 'unknown_error');
                return;
            }
            // check and update billing address
            const billingAddressToSet = isBillingSame ? formattedShippingAddress : formattedBillingAddress;
            const billingAddressResponse = yield (0, utils_1.callBillingAddressEndpoint)(billingAddressToSet, (!isBillingSame && isBillingAddressFilled));
            if (!billingAddressResponse.success) {
                (0, actions_1.displayError)('There was an unknown error while validating your billing address.', 'generic', 'unknown_error');
                return;
            }
            // update taxes
            const taxResponse = yield (0, checkout_frontend_library_1.setTaxes)(types_1.API_RETRY);
            if (!taxResponse.success) {
                (0, actions_1.displayError)('There was an unknown error while calculating the taxes.', 'payment_gateway', 'no_tax');
                return;
            }
            // add payment
            const { order_total } = (0, checkout_frontend_library_1.getApplicationState)();
            const payment = {
                token: `${id}:${payer.payer_id}`,
                nonce: `${id}:${payer.payer_id}`,
                gateway_public_id: (0, managePaypalState_1.getPaypalGatewayPublicId)(),
                currency: currencyCode,
                amount: order_total
            };
            const paymentResult = yield (0, checkout_frontend_library_1.addPayment)(payment, types_1.API_RETRY);
            if (!paymentResult.success) {
                (0, actions_1.displayError)('There was an unknown error while processing your payment.', 'payment_gateway', 'unknown_error');
                return;
            }
            // finalize order
            (0, actions_1.orderProcessing)();
        }));
    });
}
exports.paypalOnApprove = paypalOnApprove;
